import { Drawer } from '@mui/material'
import { useState } from 'react'
import { BasePathProvider } from 'components/Providers'
import LookupList from './List/List'
import LookupDetail from './List/Detail'

export default function LookupPage() {
  const [selected, setSelected] = useState(null)

  return (
    <BasePathProvider value="/lookup">
      <LookupList onRowClick={row => setSelected(row)} />
      <Drawer open={Boolean(selected)} anchor="right" onClose={() => setSelected(null)} PaperProps={{ sx: { width: 440 } }}>
        {selected && <LookupDetail person={selected} onClose={() => setSelected(null)} />}
      </Drawer>
    </BasePathProvider>
  )
}
